import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => (
  <section className="page-head" style={{ textAlign: 'center' }}>
    <h1>404</h1>
    <p className="page-sub">That page doesn't exist.</p>
    <p style={{ marginTop: '1rem' }}>
      <Link to="/" className="btn btn-primary">Back to home</Link>
    </p>
  </section>
);

export default NotFoundPage;
